// extracted by mini-css-extract-plugin
export default {"form":"TranslatePdfSectionForm_form__klN3p"};